// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__zkX6z","total":"Cart_total__E3+ug","actions":"Cart_actions__ZksR9","button--alt":"Cart_button--alt__Zzhf5","button":"Cart_button__3XHq0"};